var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickerBreadcrumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.899,
    height: 9.899
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8e8e95",
    d: "M9.192 4.243a1 1 0 010 1.414L5.656 9.192a1 1 0 01-1.414 0 1 1 0 010-1.414L7.07 4.95 4.242 2.12a1 1 0 010-1.414 1 1 0 011.414 0z"
  })));
}
export default SvgPickerBreadcrumb;